import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHome,
  faUsers,
  faMessage,
  faFileInvoiceDollar,
  faMoneyBillWave,
  faExclamationTriangle,
  faFileAlt,
  faBullseye,
  faQrcode,
  faBuilding,
  faUpload,
  faUserShield,
  faChevronDown,
  faChevronUp,
} from "@fortawesome/free-solid-svg-icons";
import { NavLink } from "react-router-dom";
import logo from "../assets/images/logo.png";
import translations from "../Translation/Sidebar.json";

export default function Sidebar({ sidebarOpen, setSidebarOpen }) {
  const [openDropdown, setOpenDropdown] = useState(null);

  const toggleDropdown = (menu) => {
    setOpenDropdown(openDropdown === menu ? null : menu);
  };

  return (
    <aside
      className={`fixed z-50 top-0 left-0 w-64 min-h-screen bg-white shadow-lg rounded-r-xl transform transition-transform duration-300 ease-in-out
        ${sidebarOpen ? "translate-x-0" : "-translate-x-full"} md:translate-x-0 md:static`}
    >
      {/* Header */}
      <div className="px-4 py-5 border-b">
        <img src={logo} alt="logo" className="w-30 h-10" />
        <h2 className="text-lg font-bold mt-2 text-blue-900 tracking-wide">
          {translations.sidebar.appName}
        </h2>
      </div>

      {/* Navigation */}
      <nav className="p-3 space-y-1">
        {/* LAMAN UTAMA */}
        <NavLink
          to="/"
          end
          onClick={() => setSidebarOpen(false)}
          className={({ isActive }) =>
            `flex items-center py-2 px-3 rounded-md text-sm font-medium transition duration-200 ${
              isActive
                ? "bg-blue-800 text-white shadow-md"
                : "hover:bg-blue-100 hover:text-blue-700 text-gray-700"
            }`
          }
        >
          <FontAwesomeIcon icon={faHome} className="mr-3 text-blue-500" />
          LAMAN UTAMA
        </NavLink>

        {/* DATA PENGHUNI PA/PPR */}
        <div>
          <button
            onClick={() => toggleDropdown("penghuni")}
            className="flex items-center justify-between w-full py-2 px-3 rounded-md text-sm font-medium text-gray-700 hover:bg-indigo-100 hover:text-indigo-700 transition"
          >
            <span className="flex items-center">
              <FontAwesomeIcon icon={faUsers} className="mr-3 text-purple-500" />
              DATA PENGHUNI PA/PPR
            </span>
            <FontAwesomeIcon
              icon={openDropdown === "penghuni" ? faChevronUp : faChevronDown}
              className="text-gray-500 text-xs"
            />
          </button>
          {openDropdown === "penghuni" && (
            <div className="ml-6 mt-1 space-y-1">
              {["ZONE 1", "ZONE 2", "ZONE 3", "ZONE 4"].map((zone, idx) => (
                <NavLink
                  key={idx}
                  to={`/data-penghuni/${zone.toLowerCase().replace(" ", "")}`}
                  onClick={() => setSidebarOpen(false)}
                  className={({ isActive }) =>
                    `block py-1.5 px-3 rounded-md text-sm ${
                      isActive
                        ? "bg-blue-700 text-white"
                        : "text-gray-700 hover:bg-blue-100 hover:text-blue-700"
                    }`
                  }
                >
                  {zone}
                </NavLink>
              ))}
            </div>
          )}
        </div>

        {/* LAPORAN CAJ */}
        <div>
          <button
            onClick={() => toggleDropdown("caj")}
            className="flex items-center justify-between w-full py-2 px-3 rounded-md text-sm font-medium text-gray-700 hover:bg-indigo-100 hover:text-indigo-700 transition"
          >
            <span className="flex items-center">
              <FontAwesomeIcon icon={faFileInvoiceDollar} className="mr-3 text-green-500" />
              LAPORAN CAJ
            </span>
            <FontAwesomeIcon
              icon={openDropdown === "caj" ? faChevronUp : faChevronDown}
              className="text-gray-500 text-xs"
            />
          </button>
          {openDropdown === "caj" && (
            <div className="ml-6 mt-1 space-y-1">
              <NavLink
                to="/laporan-caj/bulanan"
                onClick={() => setSidebarOpen(false)}
                className={({ isActive }) =>
                  `block py-1.5 px-3 rounded-md text-sm ${
                    isActive
                      ? "bg-blue-700 text-white"
                      : "text-gray-700 hover:bg-blue-100 hover:text-blue-700"
                  }`
                }
              >
                BULANAN
              </NavLink>
            </div>
          )}
        </div>

        {/* LAPORAN BAYARAN */}
        <div>
          <button
            onClick={() => toggleDropdown("bayaran")}
            className="flex items-center justify-between w-full py-2 px-3 rounded-md text-sm font-medium text-gray-700 hover:bg-indigo-100 hover:text-indigo-700 transition"
          >
            <span className="flex items-center">
              <FontAwesomeIcon icon={faMoneyBillWave} className="mr-3 text-yellow-500" />
              LAPORAN BAYARAN
            </span>
            <FontAwesomeIcon
              icon={openDropdown === "bayaran" ? faChevronUp : faChevronDown}
              className="text-gray-500 text-xs"
            />
          </button>
          {openDropdown === "bayaran" && (
            <div className="ml-6 mt-1 space-y-1">
              {["HARIAN", "MINGGUAN", "BULANAN"].map((type, idx) => (
                <NavLink
                  key={idx}
                  to={`/laporan-bayaran/${type.toLowerCase()}`}
                  onClick={() => setSidebarOpen(false)}
                  className={({ isActive }) =>
                    `block py-1.5 px-3 rounded-md text-sm ${
                      isActive
                        ? "bg-blue-700 text-white"
                        : "text-gray-700 hover:bg-blue-100 hover:text-blue-700"
                    }`
                  }
                >
                  {type}
                </NavLink>
              ))}
            </div>
          )}
        </div>

        {/* LAPORAN TUNGGAKAN */}
        <div>
          <button
            onClick={() => toggleDropdown("tunggakan")}
            className="flex items-center justify-between w-full py-2 px-3 rounded-md text-sm font-medium text-gray-700 hover:bg-indigo-100 hover:text-indigo-700 transition"
          >
            <span className="flex items-center">
              <FontAwesomeIcon icon={faExclamationTriangle} className="mr-3 text-red-500" />
              LAPORAN TUNGGAKAN
            </span>
            <FontAwesomeIcon
              icon={openDropdown === "tunggakan" ? faChevronUp : faChevronDown}
              className="text-gray-500 text-xs"
            />
          </button>
          {openDropdown === "tunggakan" && (
            <div className="ml-6 mt-1 space-y-1">
              {["MINGGUAN", "BULANAN"].map((type, idx) => (
                <NavLink
                  key={idx}
                  to={`/laporan-tunggakan/${type.toLowerCase()}`}
                  onClick={() => setSidebarOpen(false)}
                  className={({ isActive }) =>
                    `block py-1.5 px-3 rounded-md text-sm ${
                      isActive
                        ? "bg-blue-700 text-white"
                        : "text-gray-700 hover:bg-blue-100 hover:text-blue-700"
                    }`
                  }
                >
                  {type}
                </NavLink>
              ))}
            </div>
          )}
        </div>

        {/* LAPORAN BULANAN DBKL */}
        <NavLink
          to="/laporan-bulanan-dbkl"
          onClick={() => setSidebarOpen(false)}
          className={({ isActive }) =>
            `flex items-center py-2 px-3 rounded-md text-sm font-medium transition duration-200 ${
              isActive
                ? "bg-blue-700 text-white shadow-md"
                : "hover:bg-blue-100 hover:text-blue-700 text-gray-700"
            }`
          }
        >
          <FontAwesomeIcon icon={faFileAlt} className="mr-3 text-indigo-500" />
          LAPORAN BULANAN DBKL
        </NavLink>

        {/* KPI PEGAWAI HASIL */}
        <NavLink
          to="/kpi-pegawai-hasil"
          onClick={() => setSidebarOpen(false)}
          className={({ isActive }) =>
            `flex items-center py-2 px-3 rounded-md text-sm font-medium transition duration-200 ${
              isActive
                ? "bg-blue-700 text-white shadow-md"
                : "hover:bg-blue-100 hover:text-blue-700 text-gray-700"
            }`
          }
        >
          <FontAwesomeIcon icon={faBullseye} className="mr-3 text-pink-500" />
          KPI PEGAWAI HASIL
        </NavLink>

        {/* QR KOD */}
        <NavLink
          to="/qr-kod"
          onClick={() => setSidebarOpen(false)}
          className={({ isActive }) =>
            `flex items-center py-2 px-3 rounded-md text-sm font-medium transition duration-200 ${
              isActive
                ? "bg-blue-700 text-white shadow-md"
                : "hover:bg-blue-100 hover:text-blue-700 text-gray-700"
            }`
          }
        >
          <FontAwesomeIcon icon={faQrcode} className="mr-3 text-purple-500" />
          QR KOD
        </NavLink>

        {/* RAMPASAN DAN TAMAT KONTRAK */}
        <NavLink
          to="/rampasan-tamat-kontrak"
          onClick={() => setSidebarOpen(false)}
          className={({ isActive }) =>
            `flex items-center py-2 px-3 rounded-md text-sm font-medium transition duration-200 ${
              isActive
                ? "bg-blue-700 text-white shadow-md"
                : "hover:bg-blue-100 hover:text-blue-700 text-gray-700"
            }`
          }
        >
          <FontAwesomeIcon icon={faBuilding} className="mr-3 text-red-500" />
          RAMPASAN DAN TAMAT KONTRAK
        </NavLink>

        {/* MUAT NAIK */}
        <NavLink
          to="/muat-naik"
          onClick={() => setSidebarOpen(false)}
          className={({ isActive }) =>
            `flex items-center py-2 px-3 rounded-md text-sm font-medium transition duration-200 ${
              isActive
                ? "bg-blue-700 text-white shadow-md"
                : "hover:bg-blue-100 hover:text-blue-700 text-gray-700"
            }`
          }
        >
          <FontAwesomeIcon icon={faUpload} className="mr-3 text-sky-500" />
          MUAT NAIK
        </NavLink>

        {/* ADMIN */}
        <NavLink
          to="/admin"
          onClick={() => setSidebarOpen(false)}
          className={({ isActive }) =>
            `flex items-center py-2 px-3 rounded-md text-sm font-medium transition duration-200 ${
              isActive
                ? "bg-blue-700 text-white shadow-md"
                : "hover:bg-blue-100 hover:text-blue-700 text-gray-700"
            }`
          }
        >
          <FontAwesomeIcon icon={faUserShield} className="mr-3 text-teal-500" />
          ADMIN
        </NavLink>

        <NavLink
          to="/chat"
          onClick={() => setSidebarOpen(false)}
          className={({ isActive }) =>
            `flex items-center py-2 px-3 rounded-md text-sm font-medium transition duration-200 ${
              isActive
                ? "bg-blue-700 text-white shadow-md"
                : "hover:bg-blue-100 hover:text-blue-700 text-gray-700"
            }`
          }
        >
          <FontAwesomeIcon icon={faMessage} className="mr-3 text-teal-500" />
          Chat
        </NavLink>
      </nav>
    </aside>
  );
}
